import { FAMILYSITE_LIST } from '@constants/index';
import useTouchLeaveRadius from '@hooks/useTouchLeaveRadius';
import classNames from 'classnames';
import { OverlayScrollbarsComponent } from 'overlayscrollbars-react';
import 'overlayscrollbars/styles/overlayscrollbars.css';

export default function FamilySite() {
    const { isLeave, handleTouchStart, handleTouchMove, handleTouchEnd } = useTouchLeaveRadius(5);

    return (
        <div className="footer__familysite-layer">
            <OverlayScrollbarsComponent
                element="ul"
                className={classNames('footer__familysite-list', { 'is-scrolling': isLeave })}
                defer
                onTouchStart={handleTouchStart}
                onTouchMove={handleTouchMove}
                onTouchEnd={handleTouchEnd}
            >
                {FAMILYSITE_LIST.map((item) => (
                    <li key={`familysite-${item.label}`} className="footer__familysite-item">
                        <a target={item.target} href={item.href}>
                            {item.label}
                        </a>
                    </li>
                ))}
            </OverlayScrollbarsComponent>
        </div>
    );
}
